module.exports = __webpack_public_path__ + "img/Topic-healthfunding.a0a983ae.svg";